import { win } from '../context'

class Parallax {
    container: HTMLElement | null = null

    constructor(container?: HTMLElement) {
        this.container = container || document.body
    }

    init(newContainer?: HTMLElement) {
        if (win.w < 1024) return
        document.body.classList.add('parallax-init')

		const container: HTMLElement = newContainer || this.container as HTMLElement

        const sections: HTMLElement[] = Array.from(container.querySelectorAll('[data-parallax-section]')) as HTMLElement[]
        if (!sections) return

        sections.forEach((section) => {
            if (section.hasAttribute('data-parallax-disable') && win.w < parseInt(section.dataset.parallaxDisable || '0')) return
            
            const parallaxElements: HTMLElement[] = Array.from(section.querySelectorAll('[data-parallax-speed]')) as HTMLElement[]

            parallaxElements.forEach((element) => {
                if (element.hasAttribute('data-parallax-disable') && win.w < parseInt(element.dataset.parallaxDisable || '0')) return

                const speed = parseInt(element.dataset.parallaxSpeed || '0')

                gsap.fromTo(element,
                    { y: () => section.clientHeight * speed / 10 },
                    {
                        y: () => -(section.clientHeight * speed / 10),
                        ease: 'none',
                        scrollTrigger: {
                            trigger: section,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                            invalidateOnRefresh: true,
                        }
                    }
                )
            })
        })
    }

    update(newContainer: HTMLElement) {
        this.cleanup()
        this.init(newContainer)
    }

    cleanup() {
        document.body.classList.remove('parallax-init')
    }
}

export default new Parallax()